import React from 'react';

interface HomeImageProps {
  text: string[];
}

export default function HomeTextBannerAllies({ text }: HomeImageProps) {
  if (!text) {
    return (
      <div className="flex flex-col gap-2 lg:mt-5 xl:pl-20 lg:w-3/5 px-5">
        <div className="flex flex-row">
          <p className="lg:text-lg xl:text-lg md:text-base text-xs text-black mb-6">
            Somos tu partner (meit!) para construir la Organización que siempre
            has soñado: donde tus colaboradores están motivados a entregar los
            mejores resultados, a la vez que se sienten económicamente
            protegidos.
          </p>
        </div>
        <div className="flex flex-row">
          <p className="lg:text-lg xl:text-lg md:text-base text-xs text-black mb-6">
            Además, ofrece tus productos y servicios para otras compañías,
            fortaleciendo a través de meit! tus ventas corporativas.
          </p>
        </div>
      </div>
    );
  }
  return (
    <div className="flex flex-col gap-2 lg:mt-5 xl:pl-20 lg:w-3/5 px-5">
      {text?.slice(0, 3).map((textItem: string, index: number) => (
        <div key={index} className="flex flex-row">
          <p className="lg:text-lg xl:text-lg md:text-base text-xs text-black mb-6">
            {textItem}
          </p>
        </div>
      ))}
    </div>
  );
}
